<template>
  <div class="test-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>问卷管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" size="small" v-model="key"
          @keyup.enter.native="Query"></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      <div class="add"> <el-button type="primary" size="small" @click="goTo('/test-add')">+ 添加问卷</el-button></div>
    </div>
    <div class="list">
      <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName" size="small">
        <el-table-column prop="title" label="问卷名称">
        </el-table-column>
        <el-table-column prop="c_time" label="添加时间">
        </el-table-column>
        <el-table-column prop="id" label="问卷记录">
          <template slot-scope="scope">
            <el-button type="success" size="small"
              @click.native="exportData(scope.row.title, scope.row.id)">导出记录</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="goTo('/test-edit', scope.row.id)">编辑</el-button>
            <el-button type="danger" size="small" @click="deleteTest(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
        :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="选择导出时间范围" :visible.sync="centerDialogVisible" width="400px" center>
      <div align="center" class="time-screen">
        <el-date-picker v-model="time_slot" size="small" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="exportConfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      pages: 1,
      limit: 10,
      key: '',
      tableData: [],
      total: 0,
      export_test_title: '',
      export_test_id: '',
      centerDialogVisible: false,
      time_slot: ['', '']
    }
  },
  methods: {
    getList() {
      this.$get('/v1/admin/questionnaire?&pages=' + this.pages + '&limit=' + this.limit + '&key=' + this.key, {})
        .then((res) => {
          console.log(res, '答题记录')
          if (res.data.status === 'success') {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$msg(res.data.msg)
          }
        });
    },
    Query() {
      this.pages = 1;
      this.getList();
    },
    deleteTest(id) {
      this.$confirm('确定删除当前问卷？', () => {
        this.$delete('/v1/admin/questionnaire', { id: id })
          .then((res) => {
            if (res.data.status === 'success') {
              this.getList();
            } else {
              this.$msg(res.data.msg)
            }
          });
      })
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return '';
      } else {
        return 'success-row';
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList()
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages = val;
      this.getList()
      console.log(`当前页: ${val}`);
    },
    exportData(title, id) {
      this.export_test_title = title;
      this.export_test_id = id;
      this.centerDialogVisible = true;
    },
    exportConfirm() {
      this.time_slot = !this.time_slot ? ['', ''] : this.time_slot;
      this.$getFile('/v1/admin/answer-record/XL?id=' + this.export_test_id + '&start_time=' + this.time_slot[0] + '&end_time=' + this.time_slot[1], {})
        .then((res) => {
          if (res.status === 200) {
            console.log(res, 'res')
            this.downloadFile(res.data)
            this.centerDialogVisible = false
          } else {
            this.$msg(res.statusText)
          }
        });
    },
    downloadFile(file) {
      const blob = new Blob([file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' }) // 构造一个blob对象来处理数据，并设置文件类型
      if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
        navigator.msSaveBlob(blob, this.filename)
      } else {
        const href = URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
        const a = document.createElement('a') //创建a标签
        a.style.display = 'none'
        a.href = href // 指定下载链接
        a.download = this.export_test_title + '答题详情.xlsx' //指定下载文件名
        a.click() //触发下载
        URL.revokeObjectURL(a.href) //释放URL对象
      }
    },
    goTo(path, id) {
      this.$router.push({
        path: path,
        query: {
          id: id
        }
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .test-list
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 200px
        margin-right 20px
      .add
        padding-left 100px

    .list
      min-height 550px
      border 1px solid #EBEEF5
      .edit_icon
        width 20px
        height 20px
        margin-left 16px
        border 1px solid  #ccc
        border-radius 4px


</style>



// WEBPACK FOOTER //
// src/pages/TestAdd/TestList.vue